// extracted by css-extract-rspack-plugin
export default {"Sidebar":"sVpBO","Visualization":"vot1e"};